// Components
import { addToast } from "../../components/toasts";
import { EuiModalSize, addModalCloseCallback, removeModalCloseCallback, showModal } from "../../components/modal";
import { getDropdownValue } from "../../components/dropdown";
import { disableInput, enableInput } from "../../components/input";

// Models
import { Sector } from "../../models/sector";
import { Ocupation } from "../../models/ocupation";

// Actions
import { finishAddExperienceModal, onCloseModalExperiences, onCloseModalFormations, onCloseModalKillerQuestions, stepper } from "./offer-detail";

// Resources
import { GENERAL_ERROR } from "../../resources";
import { catchError } from "../../catchErrors";

// Requests
import { getSectors as getSectorsRequest, getOcupations as getOcupationsRequest, addExperienceRequest, getHaveExperience as getHaveExperienceRequest, setHaveNoExperience } from "./requests";

// Settings
import { NEW_EXPERIENCE_TOAST } from "./settings";
import { DATEPICKER_INPUT_VALUE, DATEPICKER_MIN_DATE_ATTR, dateToString } from "../../components/datepicker";

const haveExperienceYesButton = () => $("#haveExperienceYes");
const haveExperienceNoButton = () => $("#haveExperienceNo");
const addExperienceButton = () => $("#addExperienceButton");

const offerTitle = () => $("#offerDetailSettings").attr("data-OFFER_TITLE")!;
const offerDescription = () => $("#offerDetailSettings").attr("data-OFFER_LOCATION")!;

const dateStartDatepickerInput = () => $("#DateStart");
const dateEndDatepickerInput = () => $("#DateEnd");
const dateEndDatepicker = () => $("#DateEndDatepicker");
const workingHereSwitch = () => $("#DatesSwitch");

const SECTOR_SELECTOR = '#sectorSelector';
const OCUPATION_SELECTOR = '#ocupacionSelector';

$(() => {

  dateStartDatepickerInput().on("change", (event) => {
    const inputElement = event.target;
    const inputDate = inputElement.getAttribute(DATEPICKER_INPUT_VALUE)!;
    const date = new Date(inputDate)

    dateEndDatepicker().attr(DATEPICKER_MIN_DATE_ATTR, dateToString(date));
    emptyDateEndPicker();
  });

  workingHereSwitch().on("change", (event) => {
    const switchElement = event.target as HTMLInputElement;
    const dateEndElement = dateEndDatepickerInput()[0] as HTMLInputElement;
    const isSwitchEnabled = switchElement.checked;

    isSwitchEnabled ? disableInput(dateEndElement) : enableInput(dateEndElement);
    handleDateEndValidation();
    emptyDateEndPicker();
  })
});

export async function getHaveExperience(): Promise<boolean> {
  try {
    const haveExperience: boolean = await getHaveExperienceRequest();
    return haveExperience;
  } catch(error) {
    catchError(error);
    return false;
  }
}

export async function showAddExperienceModal() {
  haveExperienceYesButton().off('click', showNewExperienceStep);
  haveExperienceNoButton().off('click', setHaveNoExperienceAndCloseModal);
  haveExperienceYesButton().on('click', showNewExperienceStep);
  haveExperienceNoButton().on('click', setHaveNoExperienceAndCloseModal);

  removeModalCloseCallback('#applyOfferModal', onCloseModalExperiences);
  removeModalCloseCallback('#applyOfferModal', onCloseModalFormations);
  removeModalCloseCallback('#applyOfferModal', onCloseModalKillerQuestions);
  addModalCloseCallback('#applyOfferModal', onCloseModalExperiences);

  $("#experienceOfferTitle").text(offerTitle());
  $("#experienceOfferLocation").text(offerDescription());

  showModal('#applyOfferModal', { isFullScreen: true, overlayClose: false, size: EuiModalSize.S });

  window.dataLayer?.push({
    event: "PedirExperienciaOferta",
  });
}

async function showNewExperienceStep() {
  const sectors: Array<Sector> = await getSectors();
  const ocupations: Array<Ocupation> = await getOcupations();

  let sectorHTML: string = '';
  $(`${SECTOR_SELECTOR} .eui-dropdown__options-body`).html();
  sectors.forEach((sector: Sector) => {
    sectorHTML += `<li class="eui-d-flex eui-d-flex--vertical-center eui-cursor-pointer eui-dropdown__option" data-eui-value="${sector.id}">
      ${sector.description}
    </li>`
  });
  $(`${SECTOR_SELECTOR} .eui-dropdown__options-body`).html(sectorHTML);

  let ocupationHTML: string = '';
  $(`${OCUPATION_SELECTOR} .eui-dropdown__options-body`).html();
  ocupations.forEach((ocupation: Ocupation) => {
    ocupationHTML += `<li class="eui-d-flex eui-d-flex--vertical-center eui-cursor-pointer eui-dropdown__option" data-eui-value="${ocupation.id}">
      ${ocupation.description}
    </li>`
  });
  $(`${OCUPATION_SELECTOR} .eui-dropdown__options-body`).html(ocupationHTML);

  $("#addExperienceForm").validate();
  const formSettings = $.data($("#addExperienceForm")[0], "validator").settings;

  formSettings.submitHandler = (form: any) => {
    $("input", form).blur();
    const validator = $("#addExperienceForm").validate();
    addExperience();
  };

  stepper.next();
}

async function setHaveNoExperienceAndCloseModal() {
  await setHaveNoExperience();
  if(window.addBrazeEvent) window.addBrazeEvent("B2C - Update profile");
  closeExperienceModal();
}

async function closeExperienceModal() {
  finishAddExperienceModal();
}

async function getSectors() {
  const sectors: Array<Sector> = await getSectorsRequest();
  return sectors;
}

async function getOcupations() {
  const ocupations: Array<Ocupation> = await getOcupationsRequest();
  return ocupations;
}

async function addExperience() {
  addExperienceButton().prop("disabled", true);
  const sector: {value: string, text: string } = getDropdownValue(SECTOR_SELECTOR)!;
  const ocupation: {value: string, text: string } = getDropdownValue(OCUPATION_SELECTOR)!;
  const inputFields = $("#addExperienceForm").serializeArray();
  const company = inputFields.find((inputField) => inputField.name == 'Company');
  const dateStart = dateStartDatepickerInput().attr(DATEPICKER_INPUT_VALUE);
  const dateEnd = dateEndDatepickerInput().attr(DATEPICKER_INPUT_VALUE);
  const isWorkingHere = workingHereSwitch().is(':checked');

  const formInvalid = !sector.value || !ocupation.value || !company?.value || !dateStart || (!isWorkingHere && !dateEnd);

  if(formInvalid) {
    addToast(GENERAL_ERROR, 'error', 2000);
    addExperienceButton().prop("disabled", false);
    return;
  }

  try {
    await addExperienceRequest(
      sector.value.toString(), 
      parseInt(ocupation.value), 
      company.value, 
      dateStart, 
      isWorkingHere ? null : dateEnd!
    );
    addToast(NEW_EXPERIENCE_TOAST, 'success', 2000);
    closeExperienceModal();
    if(window.addBrazeEvent) window.addBrazeEvent("B2C - Update profile");
  } catch (error: any) {
    addToast(GENERAL_ERROR, 'error', 2000);
    addExperienceButton().prop("disabled", false);
  }
}

function handleDateEndValidation() {
  const isSwitchEnabled = workingHereSwitch().is(':checked');
  
  if (!isSwitchEnabled) {
      const validationMessage = dateEndDatepickerInput().attr('data-val-required-old')?.toString()!;
      dateEndDatepickerInput().removeAttr('data-val-required-old');
      dateEndDatepickerInput().rules('add', {
          required: true,
          messages: {
              required: validationMessage
          }
      });
  } else {
      const validationMessage = dateEndDatepickerInput().attr('data-val-required')?.toString()!;
      dateEndDatepickerInput().attr('data-val-required-old', validationMessage);
      dateEndDatepickerInput().rules('remove', 'required');
  }
}

function emptyDateEndPicker() {
  dateEndDatepickerInput().val('');
  const changeEvent = new Event("change", { bubbles: true });
  dateEndDatepickerInput()[0].dispatchEvent(changeEvent);
}